export default function PHP_error() {
  return (
    <div>
      <h1>PHP_error</h1>
    </div>
  );
}
